import { loadIntakeDraft } from '#app/routes/mocra+/_form+/generate/intake-loader.ts'

export const BIN_ID_STORAGE_KEY = 'mocra_jsonbin_bin_id' // legacy (single bin)
const BIN_MAP_STORAGE_KEY = 'mocra_jsonbin_bins' // new mapping: email -> binId
const DEBUG_FLAG_KEY = 'mocra_jsonbin_debug'

function isDebugEnabled(): boolean {
	try {
		if (typeof window === 'undefined') return false
		return window.localStorage.getItem(DEBUG_FLAG_KEY) === '1'
	} catch {
		return false
	}
}

export async function syncDraftToJsonBin(): Promise<void> {
	if (typeof window === 'undefined') return
	try {
		const draft = loadIntakeDraft()
		if (!draft || Object.keys(draft).length === 0) return
		// Resolve binId by email mapping, fallback to legacy key
		let storedId: string | undefined
		let email: string | undefined
		try {
			const maybeEmail = draft.personalInfo?.email
			if (typeof maybeEmail === 'string' && maybeEmail.includes('@')) {
				email = maybeEmail.trim().toLowerCase()
			}
		} catch {}

		try {
			const mapRaw = window.localStorage.getItem(BIN_MAP_STORAGE_KEY)
			const map = mapRaw ? (JSON.parse(mapRaw) as Record<string, string>) : {}
			if (email && map[email]) {
				storedId = map[email]
			} else {
				storedId = window.localStorage.getItem(BIN_ID_STORAGE_KEY) || undefined
				// Migrate legacy -> email mapping when we first learn email
				if (email && storedId) {
					map[email] = storedId
					window.localStorage.setItem(BIN_MAP_STORAGE_KEY, JSON.stringify(map))
					// Optionally remove legacy key after migration
					try {
						window.localStorage.removeItem(BIN_ID_STORAGE_KEY)
					} catch {}
				}
			}
		} catch {
			storedId = window.localStorage.getItem(BIN_ID_STORAGE_KEY) || undefined
		}
		if (isDebugEnabled()) {
			console.debug('[MoCRA] Sync to JSONBin start', {
				hasBinId: Boolean(storedId),
				keys: Object.keys(draft),
			})
		}
		const res = await fetch('/api/mocra/submit', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ ...draft, binId: storedId }),
		})
		const json = (await res.json().catch(() => ({}))) as { binId?: string }
		if (res.ok && json.binId) {
			try {
				if (email) {
					const raw = window.localStorage.getItem(BIN_MAP_STORAGE_KEY)
					const map = raw ? (JSON.parse(raw) as Record<string, string>) : {}
					map[email] = json.binId
					window.localStorage.setItem(BIN_MAP_STORAGE_KEY, JSON.stringify(map))
				} else {
					window.localStorage.setItem(BIN_ID_STORAGE_KEY, json.binId)
				}
			} catch {}
		}
		if (isDebugEnabled()) {
			console.debug('[MoCRA] Sync to JSONBin done', {
				ok: res.ok,
				status: res.status,
				binId: json.binId ?? storedId,
			})
		}
	} catch (e) {
		if (isDebugEnabled()) {
			console.debug('[MoCRA] Sync to JSONBin error', e)
		}
	}
}
